module.exports = __webpack_public_path__ + "img/point-to-video-288a1c8ee2ea8f960ca8c01dde5834e9.png";